export const CALLOUT_TEXT_MAX_LENGTH = 40;
export const calloutSchema = {
    componentId: "Callout",
    scalarSlots: [{ key: "text", label: "Text", type: "textarea", maxLength: CALLOUT_TEXT_MAX_LENGTH }],
    mediaSlots: [],
};
//# sourceMappingURL=callout.js.map